import React, { Component } from 'react';
import PageWrapper from '../../components/PageWrapper';
import connectPage from '../../scenes/Main/index';
import styled from 'styled-components';
import { PrestoAppTheme } from 'presto-mini-apps-lib';


class Blank extends Component {

    render() {
        return (
            <PageWrapper>
                <BlankWrapper>
                </BlankWrapper>
            </PageWrapper>
        );
    }
}

export default connectPage(Blank);

const BlankWrapper = styled.div`
    min-height: 250px;
    display: flex;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    padding: 0 ${PrestoAppTheme.layout.smallGap} ${PrestoAppTheme.layout.smallGap};

`;